import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface LockedFieldOverlayProps {
  locked: boolean;
  onLockTap: () => void;
  children: React.ReactNode;
}

/**
 * Wraps a form field/section and, when `locked`, drapes a tap-capture overlay
 * over it. The children render at reduced opacity and can't receive pointer
 * events — taps anywhere on the area surface the lock prompt instead.
 */
export const LockedFieldOverlay: React.FC<LockedFieldOverlayProps> = ({
  locked,
  onLockTap,
  children,
}) => {
  const { t } = useTranslation('publish');
  if (!locked) return <>{children}</>;

  return (
    <div className="relative">
      <div className="pointer-events-none select-none opacity-60">{children}</div>
      <button
        type="button"
        onClick={onLockTap}
        aria-label={t('lockedField.aria')}
        className="absolute inset-0 z-10 flex items-start justify-end p-2"
      >
        <span className="flex h-6 w-6 items-center justify-center rounded-full border border-border bg-card shadow-sm">
          <Lock className="h-3 w-3 text-muted-foreground" />
        </span>
      </button>
    </div>
  );
};
